import { dialingCodes } from "common";
import { memoize } from "lodash";

export const findDialingCode = memoize((code: string) =>
  dialingCodes.find((el) => el.code === code)
);
